<div
  class="formfield"
  [ngStyle]="{
    marginBottom:
      !manualMode && !searchFailed && getValue('street') && getValue('city')
        ? 0
        : null,
  }"
>
  <div [formGroup]="addressForm">
    <div class="nes-grid nes-grid-cols-3 nes-gap-x-5 nes-gap-y-2">
      <div class="nes-flex nes-items-start">
        <nes-heading size="md" class="nes-text-left">
          {{ "USER_DATA.INPUT.POSTCODE.LABEL" | translate }}
        </nes-heading>
      </div>
      <div class="nes-flex nes-items-start">
        <nes-heading size="md" class="nes-text-left">
          {{ "USER_DATA.INPUT.HOUSENUMBER.LABEL" | translate }}
        </nes-heading>
      </div>
      <div class="nes-flex nes-items-start">
        <nes-heading size="md" class="nes-text-left">
          {{ "USER_DATA.INPUT.ADDITION.LABEL" | translate }}
        </nes-heading>
      </div>

      <div>
        <nes-input
          [label]="'USER_DATA.INPUT.POSTCODE.LABEL' | translate"
          [name]="'USER_DATA.INPUT.POSTCODE.NAME' | translate"
          [value]="addressForm.get('postcode')!.value"
          [formControl]="getControl('postcode')"
          formControlName="postcode"
          [cypress]="'postcode'"
          hidden-label
          nesFormControl
          controlled
          required
          forceUppercase
          receiptFooterVisibility
          privacySensitive
          [maxLength]="postcodeLength"
          nes-id="postcode"
          type="text"
        ></nes-input>
      </div>

      <div>
        <nes-input
          [label]="'USER_DATA.INPUT.HOUSENUMBER.LABEL' | translate"
          [name]="'USER_DATA.INPUT.HOUSENUMBER.NAME' | translate"
          [value]="addressForm.get('houseNumber')!.value"
          [formControl]="getControl('houseNumber')"
          formControlName="houseNumber"
          [cypress]="'house_number'"
          hidden-label
          nesFormControl
          controlled
          required
          receiptFooterVisibility
          privacySensitive
          maxLength="10"
          nes-id="houseNumber"
          type="number"
        ></nes-input>
      </div>

      <div>
        <nes-input
          [label]="'USER_DATA.INPUT.ADDITION.LABEL' | translate"
          [name]="'USER_DATA.INPUT.ADDITION.NAME' | translate"
          [value]="addressForm.get('addition')!.value"
          [formControl]="getControl('addition')"
          formControlName="addition"
          [cypress]="'addition'"
          hidden-label
          nesFormControl
          controlled
          receiptFooterVisibility
          privacySensitive
          [maxLength]="10"
          nes-id="addition"
          type="text"
        ></nes-input>
      </div>
      @if (getPostcodeErrorKey() || getHouseNumberErrorKey()) {
        <div class="nes-h-[1.5rem] nes-mt-1 nes-mb-5">
          @if (getPostcodeErrorKey() !== undefined) {
            <nes-error-message>{{ getPostcodeErrorKey() }}</nes-error-message>
          }
        </div>
        <div class="nes-h-[1.5rem] nes-mt-1 nes-mb-5">
          @if (getHouseNumberErrorKey() !== undefined) {
            <nes-error-message>{{
              getHouseNumberErrorKey()
            }}</nes-error-message>
          }
        </div>
        <div class="nes-h-[1.5rem] nes-mt-1 nes-mb-5"></div>
      }
    </div>
  </div>
</div>

<nes-message-inline
  class="formfield"
  type="error"
  *ngIf="getAddressErrorKey() !== undefined"
  [heading]="'USER_DATA.INPUT.ADDRESS.ERROR_INVALID' | translate"
>
  <nes-text class="nes-mb-3">{{ getAddressErrorKey() | translate }}</nes-text>

  <nes-button
    icon-leading="edit"
    compact
    (nesOnClick)="manual.emit(true)"
    variant="primary"
  >
    {{ "USER_DATA.INPUT.ADDRESS.MANUAL" | translate }}
  </nes-button>
</nes-message-inline>

<ng-container *ngIf="addressLoading; else address">
  <div class="formfield__inputContainer loader">
    <div class="basicLoader"></div>
  </div>
</ng-container>

<ng-template #address>
  <ng-container
    *ngIf="
      searchableAddress &&
      !manualMode &&
      !searchFailed &&
      getValue('street') &&
      getValue('city')
    "
  >
    <div
      id="address_result"
      class="formfield animated pulse nes-mt-5"
      [cypress]="'address_result'"
    >
      <nes-highlight-box type="info" icon="check-filled">
        <div class="nes-flex nes-items-center" privacySensitive>
          <span class="nes-mr-3">
            {{ getValue("street") }} {{ getValue("houseNumber") }}
            {{ getValue("addition") }}, {{ getValue("city") }}
          </span>
        </div>
      </nes-highlight-box>
    </div>
  </ng-container>
</ng-template>

<ng-container *ngIf="manualMode || !searchableAddress">
  <div [formGroup]="addressForm">
    <div class="formfield">
      <nes-input
        [label]="'USER_DATA.INPUT.STREET.LABEL' | translate"
        [name]="'USER_DATA.INPUT.STREET.NAME' | translate"
        [value]="addressForm.get('street')!.value"
        formControlName="street"
        nesFormControl
        controlled
        required
        receiptFooterVisibility
        privacySensitive
        [forceUppercase]="{ firstLetterOnly: true }"
        [cypress]="'street'"
        [maxLength]="50"
        nes-id="street"
        type="text"
      ></nes-input>
      @if (getStreetErrorKey() !== undefined) {
        <nes-error-message>
          {{ getStreetErrorKey() | translate }}
        </nes-error-message>
      }
    </div>

    <div class="formfield">
      <nes-input
        [label]="'USER_DATA.INPUT.CITY.LABEL' | translate"
        [name]="'USER_DATA.INPUT.CITY.NAME' | translate"
        [value]="addressForm.get('city')!.value"
        formControlName="city"
        nesFormControl
        controlled
        required
        privacySensitive
        [error]="getCityErrorKey() | translate"
        receiptFooterVisibility
        [forceUppercase]="{ firstLetterOnly: true }"
        [cypress]="'city'"
        [maxLength]="50"
        nes-id="city"
        type="text"
      ></nes-input>
    </div>
  </div>
</ng-container>
